// @ts-strict-ignore
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'lm-notification',
  templateUrl: 'lm-notification.component.html',
  styleUrls: [ './lm-notification.component.scss' ],
  animations: [
    trigger('notificationVisibility', [
      state('show', style({
        height: '*',
        visibility: 'visible'
      })),
      state('hide', style({
        height: '0px',
        visibility: 'collapse'
      })),
      transition('hide => show', [
        animate('1000ms ease-in')
      ]),
      transition('show => hide', [
        animate('1000ms ease-out')
      ]),
    ]),
  ],
  providers: []
})

export class LMNotificationComponent {

  @Input() isVisible: boolean | false;
  @Input() notificationType: NotificationType | 'info';
  @Input() message:  string;
  @Input() actionMessage:  string;
  @Input() userObject:  any;

  @Output() lmNotificationEvent = new EventEmitter<LMNotificationEvent>();

  public onLMNotificationEvent(event: LMNotificationEvent): void {
    this.lmNotificationEvent.emit(event);
  }

  public handleClose(): void {
    this.isVisible = false;
  }

  public handleActionClick(): void {
    this.isVisible = false;
    this.onLMNotificationEvent({notificationType: this.notificationType, userObject: this.userObject})
  }
}
